import axios from "axios";

// API base URL. Override with REACT_APP_API_URL in .env (CRA picks it up at
// build time). When unset, falls back to the production URL so existing
// builds keep working.
const API_URL = process.env.REACT_APP_API_URL || 'https://app-ws.ipoptools.com';

axios.defaults.withCredentials = true;

const instance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    // withCredentials: true
})

instance.interceptors.response.use(
    (res) => {
        return res;
    }, async (err) => {
        const originalConfig = err.config;

        if (err.response && window.location.pathname !== "/login" && !window.location.pathname.includes("/validation/") && !window.location.pathname.includes("/register/")) {
            if ((err.response.status === 401 || err.response.status === 422) && !originalConfig._retry) {
                window.location.href = "/login";
            }
        }

        return Promise.reject(err);
    }
)

export default instance;